import React, { useEffect } from "react";
import { Link } from 'react-router-dom'
import { useAuthContext } from '../backend/UseAuth'
import { useState } from 'react'
import { useSignup } from '../backend/Register'
import TableData from "../backend/TableData";
import { getDoc, collection, doc, getFirestore, getDocs, query, onSnapshot, orderBy, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import moment from "moment";

let uniquenumber = 0;

export default function Domain() {

    const db = getFirestore();
    const { user } = useAuthContext()
    const { logout } = useSignup()
    const [isLoading, setIsLoading] = useState(true);
    const [menuItems, setMenuItems] = useState([]);
    const [error, setError] = useState(null);
    const handleSubmit = (e) => {
        logout()
    }
    const [Alldocs, setAlldocs] = useState([]);
    const [singleDoc, setSingledoc] = useState([]);

    useEffect(() => {

        getDoc(doc(db, "users", user.uid)).then(docSnap => {
            if (docSnap.exists()) {
                setSingledoc(docSnap.data());
            } else {
                console.log("No such document!");
            }
        })

        const q = query(collection(db, 'Domains'));
        const unsubscribe = onSnapshot(
            q,
            snapshot => {
                if (!snapshot.empty) {
                    setMenuItems(
                        snapshot.docs.map(doc => ({
                            id: doc.id,
                            ...doc.data(),
                        }))
                    );
                }
                setIsLoading(false);
            },
            err => {
                setError(err.message);
                console.error(err.message);
            }
        );

        console.log(menuItems);
        return () => {
            unsubscribe();
        };

    }, [])






    return (
        <React.Fragment>
            <div className="overlay"></div>

            <div className="main-body-wrapper d-flex">

                <div className="sidebar-wrapper bg--accent">
                    <div className="sidebar-inner">
                        <ul className="sidebar-menu">
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/contributions" className="sidebar-menu-link"><img src="assets/images/icon/menu1.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/tests" className="sidebar-menu-link"><img src="assets/images/icon/menu2.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/domain" className="sidebar-menu-link"> <img src="assets/images/icon/menu3.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/visualization" className="sidebar-menu-link"> <img src="assets/images/icon/menu4.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/lists" className="sidebar-menu-link"> <img src="assets/images/icon/menu5.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/profile" className="sidebar-menu-link"> <img src="assets/images/icon/menu6.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="main-content">
                    <div className="main-content-inner">

                        <div className="top-menu-wrapper bg-white">
                            <div className="top-menu-inner d-flex flex-wrap gap-2 justify-content-between">
                                <div className="d-sm-block">
                                    <div className="sidebar-toggler fs--20px d-md-none"><i className="fas fa-bars"></i></div>
                                </div>
                                <a href="contributions.html" className="logo"><img src="assets/images/logo.png" alt="logo" /></a>
                                <ul className="top-menu d-flex flex-wrap gap-3">
                                    <li className="top-menu-item">
                                        <a href="#" className="top-menu-link"><i className="fas fa-bell"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <div className="dropdown-header">
                                                    <div className="d-flex flex-wrap justify-content-between pb-2">
                                                        <h6>Notifications</h6>
                                                        <span>Mark all as read</span>
                                                    </div>
                                                    <ul className="notification">
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="top-menu-item">
                                        <a href="#" className="top-menu-link"><i className="fas fa-user"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <ul className="notification">
                                                    <li className="notification-item border-0">
                                                        <div className="d-flex gap-3">
                                                            <div className="notification-item__thumb">
                                                                <i className="fas fa-user"></i>
                                                            </div>
                                                            <div className="notification-item__content">
                                                                {
                                                                    singleDoc.firstname && <h6 className="notification-item__content-name">
                                                                        {singleDoc.firstname + " " + singleDoc.lastname}
                                                                    </h6>
                                                                }
                                                                <p>Admin</p>
                                                                {
                                                                    <Link to="/profile" className="mt-3 d-block fs--14px fw-semibold">Edit Profile
                                                                    </Link>
                                                                }
                                                                {
                                                                    <Link to="/" onClick={handleSubmit} className="mt-1 d-block fs--14px fw-semibold text--danger">  Log Out
                                                                    </Link>
                                                                }
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="main-content-inner-inner">
                            <div className="card custom--card">
                                <div className="card-header pb-0 d-flex flex-wrap gap-3 justify-content-between align-items-start">
                                    <div className="card-header__left">
                                        <h4 className="title">Domains</h4>
                                        <ul className="nav-tabs nav filter mt-2">
                                            <li className="nav-item"><a href="#all-domains" className="nav-link active" data-bs-toggle="tab">All Domains</a></li>
                                        </ul>
                                    </div>
                                    <button className="btn btn--success" data-bs-toggle="modal" data-bs-target="#addDomainModal">Add Domain</button>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex flex-wrap justify-content-between gap-3 mb-4">
                                        <div className="search-wrapper">
                                            <form action="">
                                                <div className="form-group">
                                                    <input type="text" className="form-control form--control ps-5" />
                                                    <button className="btn fs--18px border-0 btn--icon" type="submit"><i className="fas fa-search"></i></button>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="d-flex flex-wrap gap-3">
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="tab-content">
                                        <div className="tab-pane show fade active" id="all-tests">
                                            <table className="table table--responsive--xl">
                                                <thead>
                                                    <tr>
                                                        <th>Domain</th>
                                                        <th>Description</th>
                                                        <th>Staff</th>
                                                        <th>View Repository</th>
                                                        <th>Edit</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(
                                                        menuItems.map(({ DomainLanguage, Description, Staff }) => (

                                                            <tr>
                                                                <td data-label="Domain Name">{DomainLanguage}</td>
                                                                <td data-label="Description"><span className="text-xl-start">{Description}</span></td>
                                                                <td data-label="Staff">{Staff}</td>
                                                                <td data-label="View Repository">
                                                                    {
                                                                        <Link to="/repository" className="btn btn--primary btn--icon"><i className="fas fa-search"></i>
                                                                        </Link>
                                                                    }
                                                                </td>
                                                                <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                                <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                            </tr>
                                                        )

                                                        ))}



                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




            <div className="modal fade" id="addDomainModal" tabIndex="-1" aria-labelledby="addDomainModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content border-0">
                        <div className="modal-body">
                            <form action="">
                                <h4 className="title mb-4 pb-lg-2">Add Domain</h4>
                                <input type="text" className="form-control form--control mb-3" placeholder="Domain Name" />
                                <textarea name="" id="" cols="30" rows="10" className="form-control form--control" placeholder="Description"></textarea>
                                <div className="d-flex flex-wrap justify-content-end mt-4">
                                    <button type="submit" className="btn btn--success">Add</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}